<ng-container [formGroup]="form">
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="non-flagging-hourly-rate"
			placeholder="Non Flagging Hourly Rate"
			formControlName="nonflaggingHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('nonflaggingHourlyRate').hasError('required')"
		>
			Required
		</mat-error>
		<mat-error
			*ngIf="form.get('nonflaggingHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('nonflaggingHourlyRate').hasError('min')">
			Value must be above $0.01
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="conference-call-hourly-rate"
			placeholder="Conference Call Hourly Rate"
			formControlName="conferenceCallHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="
				form.get('conferenceCallHourlyRate').hasError('isNotNumeric')
			"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('conferenceCallHourlyRate').hasError('min')">
			Value must be above $0.01
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="training-hourly-rate"
			placeholder="Training Hourly Rate"
			formControlName="trainingHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('trainingHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('trainingHourlyRate').hasError('min')">
			Value must be above $0.01
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="travel-hourly-rate"
			placeholder="Travel Hourly Rate"
			formControlName="travelHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('travelHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('travelHourlyRate').hasError('min')">
			Value must be above $0.01
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="drug-test-hourly-rate"
			placeholder="Drug Test Hourly Rate"
			formControlName="drugTestHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('drugTestHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('drugTestHourlyRate').hasError('min')">
			Value must be above $0.01
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="daily-cell-phone-reimbursement-rate"
			placeholder="Daily Cell Phone Reimbursement Rate"
			formControlName="dailyCellPhoneReimbursementRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="
				form.get('dailyCellPhoneReimbursementRate').hasError('required')
			"
		>
			Required
		</mat-error>
		<mat-error
			*ngIf="
				form
					.get('dailyCellPhoneReimbursementRate')
					.hasError('isNotNumeric')
			"
		>
			Not a valid value
		</mat-error>
		<mat-error
			*ngIf="form.get('dailyCellPhoneReimbursementRate').hasError('min')"
		>
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="hotel-per-diem-a"
			placeholder="Hotel Per Diem 8"
			formControlName="hotelPerDiemA"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('hotelPerDiemA').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('hotelPerDiemA').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="meal-per-diem-a"
			placeholder="Meal Per Diem 8"
			formControlName="mealPerDiemA"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('mealPerDiemA').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('mealPerDiemA').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="hotel-per-diem-b"
			placeholder="Hotel Per Diem 9"
			formControlName="hotelPerDiemB"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('hotelPerDiemB').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('hotelPerDiemB').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="meal-per-diem-b"
			placeholder="Meal Per Diem 9"
			formControlName="mealPerDiemB"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('mealPerDiemB').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('mealPerDiemB').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			placeholder="Meal Bonus Applies?"
			disableOptionCentering="true"
			formControlName="mealBonusApplies"
		>
			<mat-option [value]="true">
				Yes
			</mat-option>
			<mat-option [value]="false">
				No
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			placeholder="Mileage Reimbursed?"
			disableOptionCentering="true"
			formControlName="mileageReimbursed"
		>
			<mat-option [value]="true">
				Yes
			</mat-option>
			<mat-option [value]="false">
				No
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field>
		<mat-select
			placeholder="Travel Time Applies?"
			disableOptionCentering="true"
			formControlName="travelTimeApplies"
		>
			<mat-option [value]="true">
				Yes
			</mat-option>
			<mat-option [value]="false">
				No
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field>
		<input
			type="number"
			autocomplete="minimum-shift-hours"
			matInput
			formControlName="minimumShiftHours"
			placeholder="Minimum Shift Hours"
		/>
		<mat-error>Value cannot be below 0</mat-error>
	</mat-form-field>
</ng-container>
